import { render, staticRenderFns } from "./EmailAttachmentSelect.vue?vue&type=template&id=4c82975f&"
import script from "./EmailAttachmentSelect.vue?vue&type=script&lang=js&"
export * from "./EmailAttachmentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports